import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "frequency-watch-hos" }
const _hoisted_2 = { class: "frequency-layout" }
const _hoisted_3 = { class: "frequency-filters" }
const _hoisted_4 = { class: "filter" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "dateFrom"
}, " Select From and To Date", -1 /* HOISTED */)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "filter" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "agency-id"
}, " Organization ", -1 /* HOISTED */)
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "filter" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "agency-location-id"
}, " Branch ", -1 /* HOISTED */)
const _hoisted_12 = {
  key: 0,
  class: "filter"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "client-list"
}, " Team ", -1 /* HOISTED */)
const _hoisted_14 = { class: "filter" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "frequency-variance"
}, "Frequency Variance", -1 /* HOISTED */)
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "filter" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "client-list"
}, " Discipline ", -1 /* HOISTED */)
const _hoisted_19 = { class: "filter" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "client-list"
}, " Frequency Status ", -1 /* HOISTED */)
const _hoisted_21 = {
  key: 1,
  class: "filter"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "inputLabel",
  for: "client-list"
}, "Tags ", -1 /* HOISTED */)
const _hoisted_23 = { class: "mt-4 pt-1" }
const _hoisted_24 = { class: "bg-white rounded mt-2 h-100" }
const _hoisted_25 = { class: "h-100 d-flex flex-column mb-3 mt-2" }
const _hoisted_26 = { class: "table-scroll-wrapper" }
const _hoisted_27 = { class: "table table-responsive-md border border-gray" }
const _hoisted_28 = { class: "bg-table-header" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Patient Name ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Branch ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Team ")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", null, "Discipline", -1 /* HOISTED */)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", null, "Frequency", -1 /* HOISTED */)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Frequency Status ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Start Date ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" End Date ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Visits Scheduled ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Visits Ordered ")
const _hoisted_39 = /*#__PURE__*/_createElementVNode("th", null, "Scheduled Variance", -1 /* HOISTED */)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("th", null, "Tags", -1 /* HOISTED */)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("th", null, "Actions", -1 /* HOISTED */)
const _hoisted_42 = {
  key: 0,
  class: "table-empty"
}
const _hoisted_43 = ["colspan"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h3", null, "No Tasks Found.", -1 /* HOISTED */)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 1,
  class: "table-error"
}
const _hoisted_47 = ["colspan"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading" }, null, -1 /* HOISTED */)
const _hoisted_49 = [
  _hoisted_48
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_MultiSelectFilter = _resolveComponent("MultiSelectFilter")!
  const _component_SortableTh = _resolveComponent("SortableTh")!
  const _component_ErrorMessageHandler = _resolveComponent("ErrorMessageHandler")!
  const _component_FrequencyWatchHosRow = _resolveComponent("FrequencyWatchHosRow")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_PageLayout = _resolveComponent("PageLayout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_DateRangePicker, {
            options: { startDate: _ctx.dateFrom, endDate: _ctx.dateTo }
          }, {
            default: _withCtx(() => [
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                name: "daterange",
                placeholder: "MM/DD/YYYY",
                value: _ctx.newDateRange,
                onChange: _cache[0] || (_cache[0] = (event) => _ctx.setnewTaskDateRange(event.target.value))
              }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_6)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["options"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("select", {
            class: "form-select ps-1",
            name: "agencies",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAgency) = $event)),
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateBranchesbyAgency && _ctx.updateBranchesbyAgency(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agencyOptions, (value, key) => {
              return (_openBlock(), _createElementBlock("option", {
                value: value.value,
                key: key
              }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_9))
            }), 128 /* KEYED_FRAGMENT */))
          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelSelect, _ctx.selectedAgency]
          ]),
          _createCommentVNode(" Uncomment this once BE accept multiple agencies "),
          _createCommentVNode(" <MultiSelect\r\n                        :dropDownOptions=\"agencyMultiSelectOptions\"\r\n                        labelText=\"Organizations\"\r\n                        :selectedOptions=\"selectedAgencies\"\r\n                        v-on:updateBranches=\"updateBranchesbyAgency\"\r\n                    /> ")
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_MultiSelect, {
            dropDownOptions: _ctx.branchMultiSelectOptions,
            labelText: "Branches",
            selectedOptions: _ctx.selectedBranches,
            onUpdateBranches: _ctx.updateBranches
          }, null, 8 /* PROPS */, ["dropDownOptions", "selectedOptions", "onUpdateBranches"])
        ]),
        (_ctx.selectedAgency.length && _ctx.selectedBranches.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_MultiSelectFilter, {
                ref: "teamFilter",
                id: "team-list",
                "on-fetch": _ctx.getTeamsList,
                "selected-items": _ctx.selectedTeams,
                "onUpdate:selected-items": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedTeams) = $event)),
                onSelectedItemsUpdated: _ctx.selectedTeamsUpdated,
                name: "Teams"
              }, null, 8 /* PROPS */, ["on-fetch", "selected-items", "onSelectedItemsUpdated"])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("select", {
            class: "form-select ps-1",
            name: "weekday-range",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.frequencyVariance) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.FrequencyVarianceEnums), ([key, value]) => {
              return (_openBlock(), _createElementBlock("option", {
                value: value.value,
                key: key
              }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_16))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [_vModelSelect, _ctx.frequencyVariance]
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_MultiSelectFilter, {
            ref: "tasksFilter",
            id: "discipline-list",
            "on-fetch": _ctx.disciplineFetch,
            "selected-items": _ctx.selectedTasks,
            "onUpdate:selected-items": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTasks) = $event)),
            onSelectedItemsUpdated: _ctx.selectedItemsUpdated,
            name: "Discipline"
          }, null, 8 /* PROPS */, ["on-fetch", "selected-items", "onSelectedItemsUpdated"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_component_MultiSelectFilter, {
            ref: "statusFilter",
            id: "status-list",
            "on-fetch": _ctx.frequencyStatusesFetch,
            "selected-items": _ctx.selectedStatuses,
            "onUpdate:selected-items": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedStatuses) = $event)),
            onSelectedItemsUpdated: _ctx.selectedStatusesUpdated,
            name: "Statuses"
          }, null, 8 /* PROPS */, ["on-fetch", "selected-items", "onSelectedItemsUpdated"])
        ]),
        (_ctx.selectedAgency.length && _ctx.selectedBranches.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_MultiSelectFilter, {
                ref: "tagsFilter",
                id: "tags-list",
                "on-fetch": _ctx.fetchTags,
                "selected-items": _ctx.selectedTags,
                "onUpdate:selected-items": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedTags) = $event)),
                onSelectedItemsUpdated: _ctx.selectedTagsUpdated,
                name: "Tags"
              }, null, 8 /* PROPS */, ["on-fetch", "selected-items", "onSelectedItemsUpdated"])
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary me-2",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.generate()))
          }, "Generate"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearFilters()))
          }, "Clear")
        ])
      ]),
      _createElementVNode("main", _hoisted_24, [
        _createVNode(_component_PageLayout, null, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_Pagination, {
                  ref: "freqyencyWatchHosPagination",
                  pageChanged: _ctx.pageChangedCallback,
                  isLoading: _ctx.isLoading,
                  entity: "Frequency Watch",
                  showPageSizeOptions: true,
                  classes: "pagination-footer pb-2",
                  pageSize: _ctx.pageSize,
                  onUpdatePageSizeChanged: _ctx.updatePageSizeChanged
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("table", _hoisted_27, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_28, [
                          _createCommentVNode(" <th></th> "),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "patientName",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_29
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "branchName",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_30
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "teamName",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_31
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _hoisted_32,
                          _hoisted_33,
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "frequencyStatus",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_34
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "startDate",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_35
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "endDate",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_36
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "visitsScheduled",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_37
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_SortableTh, {
                              "sort-by": _ctx.sortBy,
                              onSortByUpdated: _ctx.sortByUpdated,
                              "sort-order": _ctx.sortOrder,
                              onSortOrderUpdated: _ctx.sortOrderUpdated,
                              "sort-string": "visitsOrdered",
                              class: "justify-content-start"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_38
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["sort-by", "onSortByUpdated", "sort-order", "onSortOrderUpdated"])
                          ]),
                          _hoisted_39,
                          _hoisted_40,
                          _hoisted_41
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        _createCommentVNode(" EMPTY "),
                        (!_ctx.isLoading && !_ctx.isError && !_ctx.hasData)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                              _createElementVNode("td", { colspan: _ctx.columns }, _hoisted_45, 8 /* PROPS */, _hoisted_43)
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" ERROR "),
                        (!_ctx.isLoading && _ctx.isError)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                              _createElementVNode("td", { colspan: _ctx.columns }, [
                                _createVNode(_component_ErrorMessageHandler, {
                                  title: "Frequency Watch list",
                                  onTryAgain: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pageReset()))
                                })
                              ], 8 /* PROPS */, _hoisted_47)
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createCommentVNode(" LOADING "),
                        (_ctx.isLoading)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.loadingCount, (i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "table-loading",
                                key: i
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (i) => {
                                  return (_openBlock(), _createElementBlock("td", { key: i }, _hoisted_49))
                                }), 128 /* KEYED_FRAGMENT */))
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createCommentVNode(" LIST "),
                      (!_ctx.isLoading && !_ctx.isError && _ctx.hasData)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.page.Items, (item) => {
                            return (_openBlock(), _createElementBlock("tbody", {
                              key: item.PatientId
                            }, [
                              _createVNode(_component_FrequencyWatchHosRow, {
                                frequencyItem: item,
                                columns: _ctx.columns,
                                frequencyDiscipline: _ctx.frequencyDiscipline,
                                application: _ctx.application,
                                selectedAgency: _ctx.selectedAgency,
                                selectedBranches: _ctx.selectedBranches[0]
                              }, null, 8 /* PROPS */, ["frequencyItem", "columns", "frequencyDiscipline", "application", "selectedAgency", "selectedBranches"])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["pageChanged", "isLoading", "pageSize", "onUpdatePageSizeChanged"])
              ])
            ])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}